import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Rx';
@Injectable()
export class PassdataService {
// this service use for popup open from maker component on maker click to addassets component 
openClosemakerPopup: Subject<any> = new Subject();
maintClosemakerPopup: Subject<any> = new Subject();
markerlatlng:Subject<any>= new Subject();//hide marker
removeMarkerMap :Subject<any>=new Subject();
skiPoi:Subject<any>= new Subject();
moveMaintenanceOprational :Subject<any>=new Subject();

  constructor() { }


  		



}



// WEBPACK FOOTER //
// ./src/app/services/passdata/passdata.service.ts